import { useSSRData } from 'hooks';
import { useIntl, defineMessages } from 'react-intl';
import { getAlgoliaAppInfo } from 'utils';
import getFirstCorrectData from './utils';

const messages = defineMessages({
    relevance: {
        id: 'listing.sorting.relevance',
        defaultMessage: 'Relevance',
        description: 'Relevance label of the sorting button',
    },
    priceAsc: {
        id: 'listing.sorting.price_asc',
        defaultMessage: 'Price ascending',
        description: 'Ascending price label of the sorting button',
    },
    priceDesc: {
        id: 'listing.sorting.price_desc',
        defaultMessage: 'Price descending',
        description: 'Descending price label of the sorting button',
    },
    groupeByLabel: {
        id: 'listing.sorting.price',
        defaultMessage: 'Price',
        description: 'Label of grouped price indexes',
    },
    discount: {
        id: 'listing.sorting.discount',
        defaultMessage: 'Discount',
        description: 'Discount label of the sorting button',
    },
});

const useAlgoliaAppInfo = () => {
    const state = useSSRData();
    const intl = useIntl();
    const algoliaData = getFirstCorrectData(
        state.algolia,
        getAlgoliaAppInfo(),
        {},
    );

    const indexes = algoliaData.indexes;

    return {
        ...algoliaData,
        appId: algoliaData.app_id,
        searchApiKey: algoliaData.search_api_key,
        defaultIndex: indexes.relevance,
        indexes: [
            {
                label: intl.formatMessage(messages.relevance),
                value: indexes.relevance,
            },
            {
                label: intl.formatMessage(messages.priceAsc),
                value: indexes.price_asc,
                urlValue: 'price.asc',
                groupBy: intl.formatMessage(messages.groupeByLabel),
            },
            {
                label: intl.formatMessage(messages.priceDesc),
                value: indexes.price_desc,
                urlValue: 'price.desc',
                groupBy: intl.formatMessage(messages.groupeByLabel),
            },
            {
                label: intl.formatMessage(messages.discount),
                value: indexes.discount,
                urlValue: 'discount',
            },
        ],
    };
};

export default useAlgoliaAppInfo;
